<template>
  <div class="sw-panel sw-mini">
    <div class="sw-mini__jump">
      <span>Profissional</span>
      <ScheduleFilterSelect
        :model-value="idProf"
        :options="professionals"
        option-label="prof_name"
        option-value="id_prof"
        placeholder="Profissional"
        searchable
        show-clear
        @update:modelValue="$emit('update:idProf', $event)"
        @change="$emit('change-prof', $event)"
      />
    </div>
    <label class="sw-mini__jump">
      Ir para a data
      <input
        type="date"
        class="form-control form-control-sm"
        :value="selectedDate"
        @change="onJump"
      >
    </label>
    <BusyRate
      compact
      :prof-id="idProf"
      :spec-id="idSpec"
      :selected-date="selectedDate"
      @onSelectDate="$emit('select-date', $event)"
    />
  </div>
</template>

<script>
import BusyRate from '../BusyRate.vue';
import ScheduleFilterSelect from './ScheduleFilterSelect.vue';

export default {
  name: 'ScheduleMiniCalendar',
  components: { BusyRate, ScheduleFilterSelect },
  props: {
    selectedDate: { type: String, required: true },
    idProf: { default: null },
    idSpec: { default: null },
    professionals: { type: Array, default: () => [] },
  },
  emits: ['select-date', 'update:idProf', 'change-prof'],
  methods: {
    onJump(event) {
      if (event.target.value) this.$emit('select-date', event.target.value);
    },
  },
};
</script>
